export interface ICreateAbsencePopup{
    show(): Promise<any | null>
    close(result)
}
export class CreateAbsencePopup {
  absence_data: null;
    preselected_date: null;
    errors: {};
    showed: boolean;
    resolve: (value: unknown) => void;
  constructor() {
    this.showed = false;
    this.absence_data = null;
    this.preselected_date = null;
    this.errors = {};
  }

  async show(absenceData = null) {
    return new Promise((resolve) => {
      this.showed = true;
      this.absence_data = absenceData;
      this.preselected_date = null; 
      this.errors = {};
      this.resolve = resolve;
    });
  }

  async showWithDate(date, absenceData = null) {
    return new Promise((resolve) => {
      this.showed = true;
      this.absence_data = absenceData;
      this.preselected_date = date; 
      this.errors = {};
      this.resolve = resolve;
    });
  }

  close(absence) {
    this.showed = false;
    this.absence_data = null;
    this.preselected_date = null;
    this.errors = {};
    if (this.resolve) {
      this.resolve(absence);
    }
  }

  setErrors(errors) {
    this.errors = errors;
  }
}